import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @congress/platform-helpers v1.1.11
 * @version 1.1.11
 * @author Vincent Le Quec
 * @copyright Vincent Le Quec 2021-2022
 * @license CYIM: www.cyim.com
 */
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import Configuration from '../common/config.js';
/**
 * @module FirebaseHelper
 * @type {{getInstance: (function(*=, *=): Promise<{rtdb: *, FieldValue: *, db: *}|undefined>)}}
 */

var FirebaseHelper = function () {
  var instance;
  /**
   * Create an instance of FirebaseHelper
   * @throws {"VUE_APP_GRAPHQL_HTTP: A GraphQl http endpoint is required !"}
   * @throws {"VUE_APP_FIREBASE_OPTIONS: Firebase options are required !"}
   * @returns {Promise<{rtdb: firebase.database.Database, FieldValue: firebase.firestore.FieldValue, db: firebase.firestore.Firestore}>}
   */

  function createInstance(_x, _x2) {
    return _createInstance.apply(this, arguments);
  }
  /**
   * Fetch GraphQl to get a new token
   * @param graphQLEndpoint
   * @returns {Promise<null|string>}
   * @private
   */


  function _createInstance() {
    _createInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(firebaseOptions, graphQlUrl) {
      var firebaseApp, authentication, options, url, token, firebaseAuth;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!firebaseOptions && !Configuration.value("VUE_APP_FIREBASE_OPTIONS"))) {
                _context.next = 2;
                break;
              }

              throw "VUE_APP_FIREBASE_OPTIONS: Firebase options are required !";

            case 2:
              _context.prev = 2;
              options = firebaseOptions || Configuration.value("VUE_APP_FIREBASE_OPTIONS");
              firebaseApp = !firebase.apps.length ? firebase.initializeApp(JSON.parse(atob(options))) : firebase.app();

              if (!(graphQlUrl || Configuration.value("VUE_APP_GRAPHQL_HTTP"))) {
                _context.next = 18;
                break;
              }

              url = graphQlUrl || Configuration.value("VUE_APP_GRAPHQL_HTTP");
              _context.next = 9;
              return _getFirestoreToken(url);

            case 9:
              token = _context.sent;
              firebaseAuth = firebaseApp.auth();
              _context.next = 13;
              return firebaseAuth.signInWithCustomToken(token);

            case 13:
              authentication = _context.sent;

              if (!authentication) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                db: firebaseApp.firestore(),
                rtdb: firebaseApp.database(),
                FieldValue: firebase.firestore.FieldValue,
                rtdbTimestamp: firebase.database.ServerValue.TIMESTAMP
              });

            case 16:
              _context.next = 20;
              break;

            case 18:
              console.warn("You may want to be firebase authenticated, if so please provide the graphQL url");
              return _context.abrupt("return", {
                db: firebaseApp.firestore(),
                rtdb: firebaseApp.database(),
                FieldValue: firebase.firestore.FieldValue,
                rtdbTimestamp: firebase.database.ServerValue.TIMESTAMP
              });

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              throw new Error(_context.t0);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 22]]);
    }));
    return _createInstance.apply(this, arguments);
  }

  function _getFirestoreToken(_x3) {
    return _getFirestoreToken2.apply(this, arguments);
  }
  /**
   * Get token from AuthHelper
   * @returns {Promise<string>}
   * @private
   */


  function _getFirestoreToken2() {
    _getFirestoreToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(graphQLEndpoint) {
      var token, result, _result, _result$data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getAuthToken();

            case 2:
              token = _context2.sent;
              _context2.next = 5;
              return fetch(graphQLEndpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': "Bearer " + token
                },
                body: JSON.stringify({
                  query: "\n                query {\n                  firebaseToken\n                }\n            "
                })
              });

            case 5:
              result = _context2.sent;

              if (!result) {
                _context2.next = 11;
                break;
              }

              _context2.next = 9;
              return result.json();

            case 9:
              result = _context2.sent;
              return _context2.abrupt("return", (_result = result) === null || _result === void 0 ? void 0 : (_result$data = _result.data) === null || _result$data === void 0 ? void 0 : _result$data.firebaseToken);

            case 11:
              return _context2.abrupt("return", null);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getFirestoreToken2.apply(this, arguments);
  }

  function _getAuthToken() {
    return _getAuthToken2.apply(this, arguments);
  }

  function _getAuthToken2() {
    _getAuthToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _window, _window$AuthHelper;

      var token;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (_window = window) === null || _window === void 0 ? void 0 : (_window$AuthHelper = _window.AuthHelper) === null || _window$AuthHelper === void 0 ? void 0 : _window$AuthHelper.getToken();

            case 2:
              token = _context3.sent;
              return _context3.abrupt("return", token || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6Ijg1MzI2M2EyLTQyNDItNDlmOC04NTJhLThjMTI1M2U3ZDA4NiIsInBlcm1pc3Npb25zIjpbInJlYWRBbGwiLCJ3cml0ZUFsbCJdLCJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkN5aW0iLCJpYXQiOjE1MTYyMzkwMjJ9.AxOYR_dzjD1SwPMpj5V3u7zHmkCY0nrWEOdsiLFXhz0");

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _getAuthToken2.apply(this, arguments);
  }

  return {
    /**
     * Return instance of FirebaseHelper or create it
     * @returns {Promise<{rtdb: firebase.database.Database, FieldValue: firebase.firestore.FieldValue, db: firebase.firestore.Firestore}>}
     */
    getInstance: function getInstance() {
      var firebaseOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var graphQlUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!instance) {
        instance = createInstance(firebaseOptions, graphQlUrl);
      }

      return instance;
    }
  };
}();

export { FirebaseHelper };
//# sourceMappingURL=index.js.map
